$(document).ready(function(){
  $forms = $('.application-form, .candidate-proposal-form, .hearing-response-form');
  if($forms.length > 0) {
    $forms.each(function(index, form) {
      let $form = $(form);
        if($form.data('lang') == 'no') {
          $form.find('.codedropz-upload-inner span').html('eller');
          $form.find('.codedropz-upload-inner span').first().html('Dra og slipp filer her');
          $form.find('.codedropz-upload-inner .cd-upload-btn').html('Bla gjennom filer');
        }
    });
  }
});